import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { requestPasswordRecovery } from '../utils/passwordRecovery.js';

export default function ForgotPassword() {
  const { auth } = useAuth();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const pending = useRef(null);
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; pending.current?.abort(); }; }, []);

  async function submit(event) {
    event.preventDefault();
    if (pending.current) return;
    const controller = new AbortController();
    pending.current = controller;
    setBusy(true); setError(''); setMessage('');
    try {
      const result = await requestPasswordRecovery({ baseUrl: auth.baseUrl, email, signal: controller.signal });
      if (mounted.current) setMessage(result);
    } catch (failure) {
      if (mounted.current) setError(failure.message);
    } finally {
      if (pending.current === controller) pending.current = null;
      if (mounted.current) setBusy(false);
    }
  }

  return <main className="login-page">
    <section className="login-card" style={{ width: 'min(100%, 440px)', margin: '2rem auto', padding: '1.5rem' }} aria-labelledby="recovery-title">
      <h1 id="recovery-title">Forgot your password?</h1>
      <p>Enter the email you use to sign in to Photo Harbor. If an account matches, Dailey Core will send a secure reset link.</p>
      <p id="recovery-scope"><strong>This resets your shared Dailey Core password.</strong> Changing it also changes the password you use in other apps connected to the same Core account, not just Photo Harbor. Requesting a link does not change your password.</p>
      <form onSubmit={submit} aria-busy={busy} aria-describedby="recovery-scope">
        <label htmlFor="recovery-email">Email address</label>
        <input id="recovery-email" className="login-input" type="email" autoComplete="email" required maxLength={254}
          value={email} onChange={e => setEmail(e.target.value)} disabled={busy || !!message} />
        <p role="status" aria-live="polite">{busy ? 'Requesting reset link…' : message}</p>
        {error && <p role="alert">{error}</p>}
        {!message && <button className="login-btn login-btn-primary" type="submit" disabled={busy}>
          {busy ? 'Requesting…' : 'Send reset link'}
        </button>}
      </form>
      <p>If your previous link expired or was already used, request a new one here. Use the latest email link and follow its password requirements.</p>
      <Link to="/login">Back to sign in</Link>
    </section>
  </main>;
}
